import { ReportStudioElementMetadata } from '@/modules/ta/reportstudio/models/ReportStudioElementMetadata';
import { IconDesignOption } from '@/modules/ta/reportstudio/models/element/metadata/IconDesignOption';

export class ReportStudioIconElementMetadata extends ReportStudioElementMetadata {
  /**
   * @var {string}
   */
  icon;

  constructor(model = {}) {
    super(model);
    this.icon = model.icon ?? 'icon-start';
    this.design_options = new IconDesignOption(model.design_options);
  }
}
